import React from 'react'
import PropTypes from 'prop-types'

const FacebookIcon = (props) => {
  const { color = '#ffffff', classes = 'w-20', revert = false } = props
  const colorIcon = revert ? '#294DA5' : color
  const background = revert ? color : '#294DA5'
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <g clipPath="url(#clip0_3180_21462)">
        <path
          d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z"
          fill={background}
        />
        <path
          d="M13.4931 12.0868H11.2742V20.0005H7.9863V12.0868H6.41998V9.2915H7.9863V7.48203C7.9863 6.18835 8.60051 4.16309 11.3053 4.16309L13.7421 4.17361V6.88677H11.9742C11.8756 6.88161 11.777 6.89833 11.6856 6.93575C11.5942 6.97317 11.5122 7.03035 11.4455 7.10319C11.3788 7.17604 11.329 7.26274 11.2998 7.35708C11.2705 7.45143 11.2625 7.55107 11.2763 7.64888V9.29414H13.7821L13.4931 12.0868Z"
          fill={colorIcon}
        />
      </g>
      <defs>
        <clipPath id="clip0_3180_21462">
          <rect width="20" height="20" fill={colorIcon} />
        </clipPath>
      </defs>
    </svg>
  )
}

FacebookIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
  revert: PropTypes.bool,
}

export default React.memo(FacebookIcon)
